import { error } from '@react/react-spectrum/Toast';
import { useEffect, useState } from 'react';

import { commonApi, handleApiCall } from '@exchange-frontends/api';

export default function useStaticData(slice = 'All', cloud, appType) {
  const [staticData, setStaticData] = useState(null);
  useEffect(() => {
    let mounted = true;
    const handler = handleApiCall(commonApi.staticData, {
      slice,
      cloud,
      appType
    });
    (async () => {
      try {
        const response = await handler.run();
        if (mounted) {
          setStaticData(response);
        }
      } catch (err) {
        if (err.code !== 20) {
          error(err.userMessage, { timeout: 0 });
          console.error(err);
        }
      }
    })();
    return () => {
      mounted = false;
      handler.controller.abort();
    };
  }, [slice, cloud, appType]);
  return staticData;
}
